import { Hidden } from "@material-ui/core";
import AppBar from '@material-ui/core/AppBar';
import Dialog from '@material-ui/core/Dialog';
import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';
import Slide from '@material-ui/core/Slide';
import { makeStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from "@material-ui/core/Typography";
import CloseIcon from '@material-ui/icons/Close';
import Search from "@material-ui/icons/Search";
import Button from 'components/CustomButtons/Button';
import Companies from "components/Header/SearchComponents/Companies";
import React, { memo, useState } from 'react';
import commonStyle from "assets/jss/common/common";
import Box from '@mui/material/Box'
import ClickAwayListener from '@mui/material/ClickAwayListener';
const useStyles = makeStyles((theme) => ({
    paperInDlg: {
        overflowX: 'hidden'
    },
    appBar: {
        position: 'relative',
    },
    title: {
        marginLeft: '1rem',
        flex: 1,
        color: 'white'
    },
    colorPrimary: {
        color: 'white'
    },
    searchBox: {
    },
    searchIconButton: {
        margin: 0
    },
    modal: {
        fontSize: '1rem',
        position: 'absolute',
        top: '5rem',
        right: 0,
        left: 0,
        width: '50rem',
        height: '30rem',
        overflowY: 'scroll',
        zIndex: 10,
        border: `1px solid ${commonStyle.infoColor}`,
        padding: '1rem',
        backgroundColor: theme.palette.background.paper,
        maxHeight: '50vh',
        ...commonStyle.box
    }
}));
export const defaultStocks = [
    {
        id: 691,
        ticker: 'AAPL US',
        name: 'Apple Inc.'
    },
    {
        id: 591,
        ticker: 'AMZN US',
        name: "Amazon.com, Inc."
    },
    {
        id: 8180,
        name: "GameStop Corp. Class A",
        ticker: "GME US",
    },
    {
        id: 109510,
        name: "Destra Wolverine Dynamic Asset Fund Class C",
        ticker: "DWACX US",
    },
    {
        id: 25896,
        name: "AMC Entertainment Holdings, Inc. Class A",
        ticker: "AMC US",
    },
    {
        id: 45441,
        name: "Phunware, Inc.",
        ticker: "PHUN US",
    },
    {
        id: 1410,
        name: "Humana Inc.",
        ticker: "HUM US"
    }
]
interface PropTypes {
    buttonComponent?: any | null,
    onClickCompany?: any | null
}
function SearchBoxComponent(props: PropTypes) {

    const classes: any = useStyles();

    const [modalOpen, setModalOpen] = useState(false)
    const [anchorEl, setAnchorEl] = React.useState(null);

    const buttonComponent = props.buttonComponent
    const onClickCompany = props.onClickCompany
    
    const handleClick = (event) => {
        setModalOpen(true)
        setAnchorEl(event.currentTarget);
    };




    const handleClose = () => {
        setAnchorEl(null);

    };

    const renderButton = () => {
        if (buttonComponent) {
            return <div data-tut="search_nav" onClick={handleClick} style={{ cursor: 'pointer', }}>{buttonComponent}</div>
        } else {
            return <Button justIcon color='transparent' size='lg' onClick={handleClick}
                className={classes.searchIconButton}
                data-tut="search_nav" >
                <Search style={{ width: '3rem', height: '3rem'}} />
            </Button>
        }
    }

    const goCompanyPage = (item) => {
        onClickCompany(item)
        setModalOpen(false)
    }
    const popover_open = modalOpen && Boolean(anchorEl);
    const id = popover_open ? 'simple-popover' : undefined;
    return <div className={classes.searchBox}>

        <Hidden smDown>
            <Box sx={{ position: 'relative', display: 'flex' }}>
                {renderButton()}

                <Popover
                    id={id}
                    open={popover_open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <div style={{ width: '60rem' }}>
                        <Companies {...props} onClose={() => setModalOpen(false)} onClickCompany={goCompanyPage} />
                    </div>
                </Popover>
            </Box>
        </Hidden>
        <Hidden mdUp>
            {renderButton()}

            <Dialog fullScreen open={modalOpen} onClose={() => setModalOpen(false)}
                classes={{
                    paper: classes.paperInDlg
                }}>

                <div className={classes.paddingContent}>
                    <Companies {...props} onClose={() => setModalOpen(false)} onClickCompany={goCompanyPage} />
                </div>
            </Dialog>
        </Hidden>
    </div>;
}

export default memo(SearchBoxComponent)